module.exports = "<span style=\"line-height: 25px;\">Strana <b>{{currentPage}}</b>/{{totalPages}}</span>"